export default __webpack_public_path__ + "static/media/speedway.d0c241b6.jpg";